import { getMatchKickoffDayjs } from './dateHelper'
import type { AdminMatchListItem } from '../services/adminMatchesService'

function getMatchDateStr(date: string | Date): string {
  if (date instanceof Date) return date.toISOString().split('T')[0]
  return String(date).split('T')[0]
}

/** Kickoff ms for admin grouping; TBD times count as end of match day (still upcoming until day ends). */
export function getAdminMatchKickoffMs(match: Pick<AdminMatchListItem, 'date' | 'time'>): number {
  const timeRaw = match.time != null ? String(match.time).trim().toUpperCase() : ''
  if (!timeRaw || timeRaw === 'TBD') {
    return getMatchKickoffDayjs({ date: getMatchDateStr(match.date), time: '23:59:59' }).valueOf()
  }
  return getMatchKickoffDayjs({ date: getMatchDateStr(match.date), time: match.time }).valueOf()
}

export function dedupeAdminMatches<T extends { id?: string; _id?: string; index?: string }>(
  matches: T[],
): T[] {
  const seen = new Set<string>()
  const out: T[] = []
  for (const m of matches) {
    const key = String(m.id || m._id || m.index || '')
    if (!key || seen.has(key)) continue
    seen.add(key)
    out.push(m)
  }
  return out
}

export function splitAdminMatchesByKickoff(
  matches: AdminMatchListItem[],
  nowMs: number = Date.now(),
): { upcoming: AdminMatchListItem[]; past: AdminMatchListItem[] } {
  const stamped = matches.map((m) => ({ match: m, ms: getAdminMatchKickoffMs(m) }))

  const upcoming = stamped
    .filter(({ ms }) => ms > nowMs)
    .sort((a, b) => a.ms - b.ms)
    .map(({ match }) => match)

  const past = stamped
    .filter(({ ms }) => ms <= nowMs)
    .sort((a, b) => b.ms - a.ms)
    .map(({ match }) => match)

  return { upcoming, past }
}

export function filterAdminMatchesForTab(
  matches: AdminMatchListItem[],
  tab: 'upcoming' | 'past',
  nowMs: number = Date.now(),
): AdminMatchListItem[] {
  const { upcoming, past } = splitAdminMatchesByKickoff(matches, nowMs)
  return tab === 'upcoming' ? upcoming : past
}

export function hasAdminMatchKickoffTotals(res: {
  upcomingTotal?: number
  pastTotal?: number
}): boolean {
  return typeof res.upcomingTotal === 'number' && typeof res.pastTotal === 'number'
}
